// This file was auto-generated by Fern from our API Definition.
export const CustomSecretFormat = {
    Text: "text",
    Json: "json",
};
